// extracted by mini-css-extract-plugin
module.exports = {"sentence":"typingGame_sentence__4xz9N","textarea":"typingGame_textarea__1N7ni","firstChar":"typingGame_firstChar__242H2"};